import React, { Component } from 'react';
import _ from 'underscore';
import Utils from '../../sequenceserver/public/js/utils';
import ClampedParagraph from '../clamped_paragraph';

class ConservedDomainsHitsTable extends Component {
    render() {
        var grayColor = 'text-neutral-500 font-normal';
        return (
            <div className="table-hit-overview">
                <div>
                    <table
                        className="table text-sm min-w-full mb-0">
                        <thead>
                            <tr>
                                <th width="3%" className={`text-left ${grayColor}`}>#</th>
                                <th width="10%" className={grayColor}>CDD Identifier</th>
                                <th className={grayColor}>Description</th>
                                <th width="5%" className={`text-right ${grayColor}`}>From</th>
                                <th width="5%" className={`text-right ${grayColor}`}>To</th>
                                <th width="10%" className={`text-right ${grayColor}`}>E value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                _.map(this.props.hits, _.bind(function (hit) {
                                    return (
                                        <tr className="hover:bg-gray-200" key={this.props.queryId + '-' + hit.num} id={this.props.queryId + '_cd_hit_' + hit.num }>
                                            <td className="text-left align-top">{hit.num + '.'}</td>
                                            <td className="align-top">
                                                <div className='relative flex flex-col items-center group'>
                                                    <div className='flex items-center w-full'>
                                                        <span className='w-full text-sm text-seqblue hover:text-seqorange download cursor-pointer py-0.5 px-0.5'>
                                                            <a className='text-sm text-seqblue hover:text-seqorange cursor-pointer' href={`https://www.ncbi.nlm.nih.gov/Structure/cdd/cddsrv.cgi?uid=${hit.description[0].accession}`} target="_blank">
                                                                {hit.description[0].id }
                                                            </a>
                                                        </span>
                                                        <div className='absolute hidden bottom-5 items-center flex-col-reverse group-hover:flex'>
                                                            <div className='w-0 h-0 border-t-[8px] border-b-[7px] rotate-[270deg] border-r-[7px] -mt-1 border-t-transparent border-b-transparent border-r-black -mr-[1px]'></div>
                                                            <span className='relative z-10 p-2 text-xs leading-4 text-center text-white whitespace-no-wrap bg-black shadow-lg rounded-[5px]'>{ hit.description[0].id }</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="description align-top">
                                                <ClampedParagraph text={hit.description[0].title}/>
                                            </td>
                                            <td className="text-right align-top">{hit.hsps[0].query_from}</td>
                                            <td className="text-right align-top">{hit.hsps[0].query_to}</td>
                                            <td className="text-right align-top">{Utils.inExponential(hit.hsps[0].evalue)}</td>
                                        </tr>
                                    );
                                }, this))
                            }
                        </tbody>
                    </table>
                </div>
                <br />
            </div>
        );
    }
}

export default ConservedDomainsHitsTable;
